import React, { Component } from "react";
import "./Logo.css";
import logo from "../images/ImageDrive4.png";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faDesktop } from "@fortawesome/free-solid-svg-icons";

class Logo extends Component {
  render() {
    // eslint-disable-next-line
    return (
      <div className="main-logo-wrapper">
        <div className="main-logo">
          {/* <div className="logo-image"><FontAwesomeIcon icon={faDesktop} /></div>
                    <div className="logo-text">
                        <div className="upper-logo-text">IMAGE</div>
                        <div className="lower-logo-text">Driving School</div> 
                    </div> */}
          <a href="https://www.brooklyndrives.com">
            <img alt="Logo of Image Driving School" src={logo} />
          </a>
        </div>
      </div>
    );
  }
}

export default Logo;
